export default __webpack_public_path__ + "static/left_back-367d44a57d41ac0e76672e39974d1c71.png";